import "./ConfirmProperty.css";
import React from "react";
import { Fragment } from "react";

const ConfirmProperty = ({
  label,
  status,
  type,
  register,
  inputProps = "",
  errors,
  name = "",
  defaultValue = "",
  disabled = false,
  watch,
  isStepVisited,
}) => {
  return (
    <Fragment>
      <label
        className={
          isStepVisited() && watch("confirm-property") === false
            ? "text-danger"
            : ""
        }
      >
        {label}
      </label>
      <label
        className="check-box input-style bg-white confirm-checkbox"
        style={{}}
      >
        {" "}
        &nbsp; {status}
        <input type={type} name={name} {...register} disabled={disabled} />
        <span className="checkmark"></span>
      </label>
    </Fragment>
  );
};

export default ConfirmProperty;
